<template>
  <div>
    <h1>对接方设置</h1>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
</style>
